import React from 'react'

import CircularProgress from '@mui/material/CircularProgress'

import styled from 'styled-components'

export default function LoadingSpinner({ styles = {}, className = '' }) {
    return (
        <Container className={className} style={styles}>
            <CircularProgress color="inherit" />
        </Container>
    )
}

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '70vh',
})
